import request from "@/utils/request";

export function saveBasEbusiness (data){
  return request({
    url:'/osp/basEbusiness/saveBo',
    method:'post',
    data: data
  })
}

export function updateBasEbusiness (data){
  return request({
    url:'/osp/basEbusiness/updateByBo',
    method:'post',
    data: data
  })
}
export function deleteBasEbusinessByIds (data){
  return request({
    url:'/osp/basEbusiness/deleteByIds',
    method:'post',
    data: data
  })
}

export function queryBasEbusinessPageList (data){
  return request({
    url:'/osp/basEbusiness/queryPageListByFilter',
    method:'post',
    data: data
  })
}
